import * as React from 'react';
import autobind from 'autobind-decorator';

import { MarketListDataService } from 'src/app/general/market/list/market-list.data';
import { MarketEditorView } from './market-editor.view';

interface MarketEditorControllerProps {
    value: number | null;
	mode: ControlMode;
	multi?: boolean;
	onChanged: (value: any) => void;
    setBusy(isBusy: boolean);
    label?: string;
    required?: boolean;
    onGetErrorMessage?: () => Promise<ValidationError[]>;
	afterLoad?: (selectedOptions: any, options: any[]) => void;
	idAgent?: number;
}

export class MarketEditorController extends React.Component<MarketEditorControllerProps, any> {
    protected marketDataService: MarketListDataService;

    constructor(props) {
        super(props);
        this.marketDataService = MarketListDataService.make();
    }

    @autobind
    protected marketQuery(q?: string): Promise<QueryResult<MarketSummary>> {
        return new Promise<QueryResult<MarketSummary>>((resolve, reject) => {
            this.props.setBusy(true);
            this.marketDataService.addFilter('isDeleted', 'eq', false);
            this.marketDataService.addSorting('id', 'asc', true);
            this.marketDataService.searchKeywords = q;
            this.marketDataService.load(query => query)
                .then((items) => {
                    this.props.setBusy(false);
                    resolve({
                        items: items,
                        totalCount: this.marketDataService.count
                    });
                });
        });
    }

    render() {
        return (
            <MarketEditorView
                marketRequest={{ query: this.marketQuery, dataSet: this.marketDataService }}
                onGetErrorMessage={this.props.onGetErrorMessage}
                {...this.props}
            />
        );
    }
}



// WEBPACK FOOTER //
// ./src/app/general/market/parts/market-editor.controller.tsx